import { createStyles } from '@mantine/core'

const useStateChildrenStyles = createStyles((theme) => ({
  icon: {
    fontSize: 30,
  },
  accept: {
    color:
      theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6],
  },
  reject: {
    color: theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6],
  },
}))

export default useStateChildrenStyles
